var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6663 3.58334V2.75001C13.6663 2.51989 13.4798 2.33334 13.2497 2.33334H9.49967V1.50001C9.49967 1.03977 9.12658 0.666672 8.66634 0.666672H5.33301C4.87277 0.666672 4.49967 1.03977 4.49967 1.50001V2.33334H0.749674C0.519556 2.33334 0.333008 2.51989 0.333008 2.75001V3.58334C0.333008 3.81346 0.519556 4.00001 0.749674 4.00001H13.2497C13.4798 4.00001 13.6663 3.81346 13.6663 3.58334ZM3.55801 17.3333C2.68123 17.3355 1.95271 16.658 1.89134 15.7833L1.16634 5.66667H12.833L12.1247 15.7833C12.0633 16.658 11.3348 17.3355 10.458 17.3333H3.55801Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.06e91e9fa994b5afa3f89936a2c1f10a.svg";
export { ForwardRef as ReactComponent };